module.exports = "<a [href]=\"fileLink\" (click)=\"downloadFile($event)\">\n  <i class=\"pe-7s-cloud-download\"></i> Download\n</a>\n"